<kendo-dialog (close)="cancel.emit()"
              class="isg-dialog-editor"
              [height]="(afUiWin.calculatedHeightLarge | async)!"
              [width]="(afUiWin.calculatedWidthMedium | async)!"
              [title]="editDataItem ? 'Edit Role' : 'Add Role'">
  <div kendoDialogBody>
    <form novalidate class="k-form" [formGroup]="editForm">

      <div class="isg-role-editor-formwrapper">

        <kendo-formfield>
          <kendo-label [for]="name" text="Role Name"></kendo-label>
          <kendo-textbox formControlName="name"
                         #name
                         required>
          </kendo-textbox>
          <kendo-formerror>Error: Name is required</kendo-formerror>
        </kendo-formfield>

        <div class="isg-rhs-group">
          <kendo-formfield>
            <isg-tri-state-checkbox formControlName="isActive"
                                    #isActive
                                    [nullable]="false"
                                    [textTrue]="'Role is Active'"
                                    [textFalse]="'Role Inactive'"
                                    [ngClass]="{'isg-isActive': editForm.controls.isActive.value}"
                                    [isDisabled]="isReadOnlyCustomControl">
            </isg-tri-state-checkbox>
          </kendo-formfield>

          <kendo-formfield>
            <isg-tri-state-checkbox formControlName="allLicenseUsers"
                                    #allLicenseUsers
                                    [nullable]="false"
                                    [textTrue]="'Role applies to everyone'"
                                    [textFalse]="'Role can be assigned to users'"
                                    [isDisabled]="isReadOnlyCustomControl">
            </isg-tri-state-checkbox>
          </kendo-formfield>
        </div>

        <kendo-formfield>

          <kendo-label
                 [for]="templateId"
                 text="(Optional) Initialize permissions from template">
          </kendo-label>
          <kendo-dropdownlist formControlName="templateId"
                              [data]="roleTemplateOptions"
                              [defaultItem]="{ name: 'Use template...', id: null }"
                              [textField]="'name'"
                              [valueField]="'id'"
                              [valuePrimitive]="true"
                              style="width:100%;"
                              #templateId
                              >
          </kendo-dropdownlist>
        </kendo-formfield>

        <kendo-formfield>
          <kendo-label [for]="roleType" text="Role Type"></kendo-label>
          <kendo-dropdownlist formControlName="roleType"
                              [data]="roleTypeOptions"
                              [textField]="'name'"
                              [valueField]="'value'"
                              [valuePrimitive]="true"
                              style="width:100%;"
                              #roleType
                              required>
          </kendo-dropdownlist>
          <kendo-formerror>Error: RoleType is required</kendo-formerror>
        </kendo-formfield>
        
        <kendo-formfield>
          <kendo-label [for]="description" text="Description"></kendo-label>
          <kendo-textarea formControlName="description"
                          #description
                          [rows]="4"></kendo-textarea>
        </kendo-formfield>

      </div>
    </form>
  </div>

  <kendo-dialog-actions *ngIf="!isReadOnlyCustomControl">
    <button kendoButton
            themeColor="primary"
            [disabled]="!editForm.valid"
            (click)="onSave($event)">
      {{ editDataItem ? 'Update' : 'Save' }}
    </button>
    <button kendoButton (click)="onCancel($event)">Cancel</button>
    
  </kendo-dialog-actions>
</kendo-dialog>
